<template>
	<div>
		<R3AutorizacaoAvulsa :visible="visible" />
		<Toast />
		<GlobalDialogs />
		<!--
			KeepAlive: ao trocar de aba no desktop, a tela anterior fica em cache
			e volta no estado em que parou (formulário, scroll, dados em memória).
			`max: 12` limita memória; `page-key` = path para cada rota ser um cache.
		-->
		<NuxtLayout>
			<NuxtPage
				:keepalive="{ max: 12 }"
				:page-key="chaveDaPagina"
			/>
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
	import { Capacitor } from "@capacitor/core";
	import { StatusBar } from "@capacitor/status-bar";
	import { FModalAuditoriaVolumeDun14 } from "~/classes/auditoriaVolumesCarga/FModalAuditoriaVolumeDun14";
	import { AUDITORIA_VOLUME_DUN14_KEY } from "~/composables/useAuditoriaVolumeDun14";

	/**
	 * Instância global do modal de Auditoria de Volume DUN14/EAN13.
	 * Criada aqui — raiz da árvore Vue — e fornecida para toda a aplicação.
	 * Qualquer componente pode injetar via useAuditoriaVolumeDun14() ou inject(AUDITORIA_VOLUME_DUN14_KEY).
	 */
	const fModalAuditoriaVolumeDun14 = new FModalAuditoriaVolumeDun14();
	provide(AUDITORIA_VOLUME_DUN14_KEY, fModalAuditoriaVolumeDun14);

	const globalDialogsRefs = ref(null);
	const deviceStore = useDeviceStore();

	const platform = Capacitor.getPlatform();
	const executionTarget = Capacitor.isNativePlatform() ? "capacitor" : "web";

	deviceStore.setPlatform(platform as "web" | "ios" | "android");
	deviceStore.setExecutionTarget(executionTarget);

	const { visible } = useAutorizacaoAvulsa();

	const sessionManager = useSessionManager();
	const userStore = useUserStore();
	const route = useRoute();

	/**
	 * Título da aba do browser = código da rotina em evidência
	 * (ex.: `B321 · Harpia WMS`). Ver `useDocumentTitleRotina`.
	 */
	useDocumentTitleRotina();

	/**
	 * Qualquer tela autenticada sem empresa na sessão → login.
	 * Evita ficar só com a mensagem "Empresa não definida na sessão."
	 */
	watch(
		() => ({
			auth: userStore.authenticated,
			empresa: Number(userStore.companyID ?? 0),
			path: route.path,
		}),
		({ auth, empresa, path }) => {
			if (!auth) return;
			if (path === "/login") return;
			if (!empresa || Number.isNaN(empresa)) {
				void sessionManager.logout("missing-company");
			}
		},
		{ immediate: true },
	);

	/**
	 * Chave estável por rota (sem query) — alinha com as abas do layout desktop.
	 * Assim `/gestaoAcessos/1150` reabre o mesmo cache ao clicar na aba.
	 */
	function chaveDaPagina(route: { path: string }) {
		const p = route.path || "/";
		if (p === "/") return "/";
		return p.replace(/\/+$/, "") || "/";
	}

	onMounted(() => {
		// Inicializa o polling de verificação de sessão e detecção de inatividade globalmente
		sessionManager.initSessionPolling();

		// Display content under transparent status bar (Android only)
		(async () => {
			if (platform === "android")
				await StatusBar.setBackgroundColor({ color: "#1e72af" });
		})();
	});

	// const { $r3ModuControleEvents } = useNuxtApp();
	//
	// const showMessageDialog = ref<boolean>(false);
	// const msgDialogContent = ref<Partial<msgDialogPropsParams>>({ mensagem: '', botoes: [], tipo: 'informa', titulo: '' });
	//
	// onMounted(() => {
	//   $r3ModuControleEvents.on('MsgDlg', (args) => {
	//
	//     // console.log("args: ", args)
	//     // msgDialogContent.value!.mensagem = args[0]?.mensagem;
	//     msgDialogContent.value!.botoes = args.botoes ? args.botoes : [];
	//     msgDialogContent.value!.mensagem = args.mensagem;
	//     msgDialogContent.value!.tipo = args.tipo;
	//     msgDialogContent.value!.titulo = args.titulo;
	//     showMessageDialog.value = true;
	//   })
	// })

	// import type { Buffer } from "buffer"

	// const captchaGerado = ref(0);
	// const captchaConfirmacao = ref(0);
	// const mostrarCaptcha = ref(false);
	// const InputCaptcha = ref();
	//
	// function limparErro(err) {
	// Go to the first lesson
	// console.log('teste clearError');
	// err.value = null;
	// };
	//
	// function showCaptcha() {
	//
	// captchaGerado.value = gerarNumCaptcha();
	// mostrarCaptcha = true;
	// setTimeout(() => document.getElementById('inputCaptcha').focus(), 1);
	//
	// }

	// function verificarTecla(event) {

	//   //
	//   if (event.target.tagName === 'INPUT') {
	//     if (event.key === 'Enter' || event.key === 'Tab') {
	//       // Pega a lista de todos os elementos focáveis na ordem em que aparecem no DOM
	//       var focaveis = Array.from(document.querySelectorAll('input, button, select, textarea, a[href]'));

	//       // Pega o índice do elemento atualmente focado
	//       var indiceAtual = focaveis.indexOf(document.activeElement);

	//       // Calcula o próximo índice (levando em consideração que a lista é cíclica)
	//       var proximoIndice = (indiceAtual + 1) % focaveis.length;

	//       // Define o foco para o próximo elemento
	//       focaveis[proximoIndice].focus();

	//       // Impede o comportamento padrão do Enter ou Tab no campo de entrada
	//       event.preventDefault();
	//     }
	//   }

	// }

	// document.addEventListener("keydown", (event) => verificarTecla(event))

	// globalThis.Buffer = Buffer
</script>
